import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { I18nextProvider } from "react-i18next";
import { getRouter } from "./router";
import i18n from "@/lib/i18n";
import "./styles.css";

if (!i18n.isInitialized) {
  throw new Error("Translations failed to initialize.");
}

const router = getRouter();

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router} />
      </I18nextProvider>
    </React.StrictMode>,
  );
}
